(function () {
    'use strict';

    var module = angular.module('uwAgenda.website');
    module.directive('websiteGeneratorLabelFilter', ['WebsiteGeneratorService', WebsiteGeneratorLabelFilterFn]);

    // filter directive for multiple shared agenda selection
    function WebsiteGeneratorLabelFilterFn(WebsiteGeneratorService) {
        var directive = {
            link: link,
            restrict: 'E',
            templateUrl: '/app/website-generator/templates/website-generator-label-filter.template.html',
            scope: {
            }
        };
        return directive;
        function link(scope, element, attrs) {
            scope.WebsiteGeneratorService = WebsiteGeneratorService;
            scope.toggleLabel = function($event, id){
                $event.stopPropagation();
                WebsiteGeneratorService.data.filterData.allPossibleLabels.forEach(label=>{
                    if(label.id===id){
                        label.selected = !label.selected;
                    }
                })
                WebsiteGeneratorService.refreshLinks();
            }
        } // link
    }
})();